import { render, staticRenderFns } from "./dashboard_builder_basic_layout.vue?vue&type=template&id=8af81342&scoped=true"
import script from "./dashboard_builder_basic_layout.vue?vue&type=script&lang=js"
export * from "./dashboard_builder_basic_layout.vue?vue&type=script&lang=js"
import style0 from "./dashboard_builder_basic_layout.vue?vue&type=style&index=0&id=8af81342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af81342",
  null
  
)

export default component.exports